import { getIcons } from "_helpers";
import { preAlertActions } from "_store";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

export { FilterOverview }

/**
 * Commposant d'affichage des détails d'un filtre
 * S'affiche sur la partie gauche de la page listant les filtres existants
 * @returns 
 */
function FilterOverview() {

    const dispatch = useDispatch()
    const filter = useSelector(state => state.filters?.item);
    const preAlerts = useSelector(state => state.preAlerts?.list);

    useEffect(() => {
        if(!preAlerts){
            dispatch(preAlertActions.getAll());
        }
    }, []);

    /**
     * Mise en forme du label affiché en fonction du champ référence
     * @param {*} champ 
     * @returns 
     */
    const getLabel = (champ) => {
        switch (champ) {
            case "COUNTRY":
                return "Les véhicules des pays: ";
            case "CITY":
                return "Les véhicules des flottes: ";
            case "BATTERY_MODEL":
                return "Equipés des types de batteries: ";
            case "PACKS_NB":
                return "Nombre de packs: ";
            case "ECU_STATIC":
                return "Avec les boitiers de type: ";
            case "URGENCY_LEVEL":
                return "Niveaux d'alerte: ";
            case "SOC":
                return "État de Charge (SOC): ";
            case "HEADER_EVTDATE":
                return "Les événements survenus entre ";
            case "PREALERTE":
                return "Pré-alertes";
            default:
                return champ;
        }
    };

    /**
     * Formatage des valeurs en fonction de leur type
     *  - tableau: transforme en chaine de caractère séparés par des virgules
     *  - date: créé une chaine de caractère en affichant la date au format local et les adjectifs nécessaires (entre, le, et ...)
     * @param {*} champ 
     * @param {*} operateur 
     * @param {*} valeur 
     * @returns 
     */
    const formatValues = (champ, operateur, valeur) => {        
        switch (operateur) {
            case "parmi":
                if (champ === 'PREALERTE') {
                    const formattedArray = valeur.map(key => {
                        const name = preAlerts[key]?.name; // Récupère le name en fonction de la clé
                        return name ? `${name} (${key})` : null; // Retourne la chaîne formatée si le name existe
                    }).filter(item => item !== null); // Filtre les valeurs null si une clé ne correspond pas
                    return formattedArray.join(', ');
                } else {
                    return valeur.join(', ');
                }
            case "compris entre":
                if (champ === 'HEADER_EVTDATE') {
                    let dateMin = new Date(valeur.min).toLocaleDateString(),
                        timeMin = new Date(valeur.min).toLocaleTimeString(navigator.language, {hour: '2-digit', minute:'2-digit'}),
                        dateMax = new Date(valeur.max).toLocaleDateString(),
                        timeMax = new Date(valeur.max).toLocaleTimeString(navigator.language, {hour: '2-digit', minute:'2-digit'});
                    return `le ${dateMin} à ${timeMin} et le ${dateMax} à ${timeMax}`
                    
                } else if (champ === 'SOC') {
                    return `entre ${valeur.min}% et ${valeur.max}%`;
                } else {
                    return `entre ${valeur.min} et ${valeur.max}`;
                }
            default:
                return valeur.join(', ');                
        }
    };

    return (
        (filter ? (
        <div className="filter-view">
            <div className="filter-view-header">
                <div className="filter-header-row">
                    <div className="filter-title"><strong>{filter.name}</strong></div>
                    <div className="filter-date">
                        <img src={getIcons('accessTimeOutlinedGrey')} alt='icone parametres' />
                        Créé le: {new Date(filter.creation_date).toLocaleDateString()}
                    </div>
                </div>  
                <div className="filter-description"><strong>Description:</strong> {filter.description}</div>
            </div>
           <div className="filter-view-body">
                <div className="filter-section-title">
                    <img src={getIcons('constructionOutlinedGrey')} alt='icone parametres' />
                    Critères
                </div>
                <div className="rules">
                    {filter.rules.map((rule, index) => (
                        <div key={index} className="rule">
                            <p>
                                <span className="rule-label">
                                    {getLabel(rule.champ)}
                                </span>
                                {" "}
                                <span className="rule-value">
                                    {formatValues(rule.champ, rule.operateur, rule.valeur)}
                                </span>
                            </p>
                        </div>
                    ))}
                </div>
           </div>   
        </div>
        ) : (
        <div className="flex items-center justify-center h-full">
            <p className="text-4xl font-extralight text-global-grey text-center">
                Sélectionnez<br/>
                un filtre pour<br/>
                en voir les détails
            </p>
        </div>)
        )
    )
}
